import React from 'react';
import backgroundImage from '../assets/images/123.jpg';

const HeroSection = () => {
  const sectionStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '35vh', // Decreased height
    width: '100%',
    maxWidth: '900px', // Decreased width
    margin: '2rem auto', // Center the section
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '30px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  };

  const contentStyle = {
    color: 'white',
    textAlign: 'center',
    maxWidth: '95vw',
    background: 'rgba(0,0,0,0.45)',
    borderRadius: '20px',
    padding: '2rem 1rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
    margin: '1rem',
  };

  return (
    <section
      id="home"
      className="hero-container hero-section"
      style={sectionStyle}
    >
      <div className="hero-content" style={contentStyle}>
        <h3 style={{ fontWeight: 400, letterSpacing: 2, color: '#ffd700', marginBottom: '1rem' }}>
          YOUR TRUSTED DENTAL EXPERT
        </h3>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 700, margin: '0.5rem 0', lineHeight: 1.2 }}>
          Gentle Dental Care <br />
          with a Healing Touch
        </h1>
        <h2 style={{ fontSize: '1.3rem', fontWeight: 500, margin: '1.5rem 0 2rem 0', color: '#fff' }}>
          Welcome to Dr. Srishti's Dentistry and Wellness Clinic
        </h2>
        <a href="#appointment" className="hero-btn">
          Book Appointment
        </a>
      </div>
    </section>
  );
};

export default HeroSection;